import React from "react";
import "./RightSection.css";
import Heading from "../Heading/Heading";
import RightImage from "./RightImage";

export default function RightSection({
  MainHeader,
  Subtitle,
  Paragraph,
  btnLink,
  btnText,
  SideImage,
}) {
  return (
    <div className="Right_Section container padding_top_bottom">
      <Heading MainHeader={MainHeader} />
      <RightImage Subtitle={Subtitle} Paragraph={Paragraph} btnLink={btnLink} btnText={btnText} SideImage={SideImage}/>
    </div>
  );
}
